var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',{staticClass:"outline-1 mb-4 rounded-lg"},[_c('v-expansion-panel-header',[_c('h3',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.title))])]),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }